import React, { ReactElement } from 'react'
import styled from 'styled-components'

import { Col, FormRow } from '../../../../1stlog-ui/src/components/Bootstrap'
import Field, {
  composeValidators,
  mustBeEmail,
  mustBePhoneNumber,
  required,
} from '../../../../1stlog-ui/src/components/Field'
import Input from '../../../../1stlog-ui/src/components/Input'

const Wrapper = styled.div``

type ContactProps = {
  requireEmail?: boolean
  isEoriRequired?: boolean
  hidden?: boolean
  hideCustomerAddressHint?: boolean
  hidePrenameSurname?: boolean
  isPhoneRequired?: boolean
  isNameRequired?: boolean
  showEori?: boolean
}

const Contact = (props: ContactProps): ReactElement => {
  const {
    requireEmail,
    isEoriRequired,
    hidden,
    hideCustomerAddressHint,
    hidePrenameSurname,
    isPhoneRequired,
    isNameRequired,
    showEori,
  } = props

  return (
    <Wrapper hidden={hidden}>
      <FormRow hidden={hidePrenameSurname}>
        <Col md={6}>
          <Field
            name="prename"
            label={i18n.t('prename', 'Vorname')}
            validate={isNameRequired ? required : undefined}
            required={isNameRequired}
          >
            <Input className="jump-target" />
          </Field>
        </Col>
        <Col md={6}>
          <Field
            name="surname"
            label={i18n.t('surname', 'Nachname')}
            validate={isNameRequired ? required : undefined}
            required={isNameRequired}
          >
            <Input className="jump-target" />
          </Field>
        </Col>
      </FormRow>
      <FormRow>
        <Col md={6}>
          <Field
            key={String(isPhoneRequired)}
            name="phone1"
            label={i18n.t('phone', 'Telefon')}
            validate={composeValidators(
              mustBePhoneNumber,
              isPhoneRequired ? required : undefined,
            )}
            required={isPhoneRequired}
          >
            <Input className="jump-target" />
          </Field>
        </Col>
        <Col md={6}>
          <Field
            key={String(requireEmail)}
            name="mail"
            label={i18n.t('email', 'E-Mail')}
            validate={composeValidators(
              mustBeEmail,
              requireEmail ? required : undefined,
            )}
            required={requireEmail}
          >
            <Input className="jump-target" />
          </Field>
        </Col>
      </FormRow>
      <FormRow>
        {showEori && (
          <Col md={6}>
            <Field
              key={String(isEoriRequired)}
              name="eori"
              label={i18n.t('eori', 'EORI')}
              required={isEoriRequired}
              validate={isEoriRequired ? required : undefined}
            >
              <Input className="jump-target" />
            </Field>
          </Col>
        )}
        <Col md={showEori ? 6 : 12}>
          <Field name="ustid" label={i18n.t('uid', 'UID')}>
            <Input className="jump-target" />
          </Field>
        </Col>
      </FormRow>
      {!hideCustomerAddressHint && (
        <FormRow>
          <Col md={12}>
            <Field
              name="customerAddressHint"
              label={i18n.t('reference_code', 'Referenzcode')}
            >
              <Input className="jump-target" />
            </Field>
          </Col>
        </FormRow>
      )}
    </Wrapper>
  )
}

export default Contact
